<template>
    <div>
        <el-date-picker v-model="datetime" type="datetime" :placeholder="config.placeholder"
            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" clearable>
        </el-date-picker>
    </div>
</template>

<script>
export default {
    name: 'FromDateTime',
    components: {},
    props: {
        value: {
            type: String,
            default: ''
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        datetime(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.datetime = value
        }
    },
    data() {
        return {
            datetime: this.value
        }
    },
    methods: {

    }
}
</script>
